import React, { useMemo } from 'react';
import { formatNumber } from '../utils/adminMetrics';

function AdminLineChart({ title, items, emptyMessage = 'No data available' }) {
  const points = useMemo(() => {
    if (!items.length) return [];
    const max = Math.max(...items.map((item) => item.count), 1);
    const width = 320;
    const height = 140;
    const padX = 8;
    const padY = 12;
    return items.map((item, index) => {
      const x = items.length === 1
        ? width / 2
        : padX + (index / (items.length - 1)) * (width - padX * 2);
      const y = height - padY - ((item.count / max) * (height - padY * 2));
      return { ...item, x, y, width, height, max };
    });
  }, [items]);

  if (!items.length) {
    return (
      <section className="admin-chart-card">
        <h3 className="admin-chart-title">{title}</h3>
        <p className="admin-chart-empty">{emptyMessage}</p>
      </section>
    );
  }

  const width = 320;
  const height = 140;
  const path = points.map((point, index) => `${index === 0 ? 'M' : 'L'}${point.x} ${point.y}`).join(' ');
  const first = points[0];
  const last = points[points.length - 1];
  const mid = points[Math.floor(points.length / 2)];

  return (
    <section className="admin-chart-card">
      <h3 className="admin-chart-title">{title}</h3>
      <div className="admin-line-wrap">
        <svg
          className="admin-line-svg"
          viewBox={`0 0 ${width} ${height}`}
          role="img"
          aria-label={`${title} line chart`}
        >
          <path d={path} className="admin-line-path" fill="none" />
          {points.map((point) => (
            <circle
              key={point.value}
              cx={point.x}
              cy={point.y}
              r="3.5"
              className="admin-line-dot"
            >
              <title>{`${point.label}: ${formatNumber(point.count)} requests`}</title>
            </circle>
          ))}
        </svg>
        <div className="admin-line-axis">
          <span>{first.label}</span>
          {mid && mid !== first && mid !== last && <span>{mid.label}</span>}
          {last !== first && <span>{last.label}</span>}
        </div>
        <div className="admin-chart-axis">Requests</div>
      </div>
    </section>
  );
}

export default AdminLineChart;
